import {getCabinetDimensions} from "./sqft3dArHelper";
import cabinetWorkspace from "../components/canvas/core/cabinet/cabinetWorkspace";

export const changeShapeLayout = (feature, shape) => {
  const relatedParentFeature = shape.getRelatedParentFeature();

  const dimensions = getCabinetDimensions(feature, relatedParentFeature);
  const layout = cabinetWorkspace.cabinetShapes.getShapeLayout(feature, relatedParentFeature)
  const lines = cabinetWorkspace.cabinetShapes.getShapeLines(layout, dimensions);

  shape.changeLines(lines);
}
